import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { StyledSentinel } from './styled';

export const StickSentinel = ({ isSticky, onStickinessUpdate }) => {
  const sentinel = useRef();
  const raf = useRef();

  const animate = useCallback(() => {
    if (sentinel.current) {
      if (!isSticky) {
        const bounds = sentinel.current.getBoundingClientRect();
        if (bounds.top < 0) onStickinessUpdate(true);
      }

      if (window.scrollY <= 1 && isSticky) {
        onStickinessUpdate(false);
      }
    }
    raf.current = requestAnimationFrame(animate);
  }, [isSticky]);

  useEffect(() => {
    cancelAnimationFrame(raf.current);
    raf.current = requestAnimationFrame(animate);
  }, [isSticky]);

  useEffect(() => {
    raf.current = requestAnimationFrame(animate);
    return () => {
      cancelAnimationFrame(raf.current);
    };
  }, []);

  return <StyledSentinel ref={sentinel} />;
};

StickSentinel.propTypes = {
  onStickinessUpdate: PropTypes.func.isRequired,
  isSticky: PropTypes.bool.isRequired,
};

StickSentinel.displayName = 'StickSentinel';

export default StickSentinel;
